import { plural } from '@cian/utils';
import { INewbuilding } from '../../../types/newbuilding';

export const getNewbuildingStatuses = (newbuilding: INewbuilding, totalImagesCount: number): string[] => {
  const { housesCount, statusText } = newbuilding;

  const statuses = [`${totalImagesCount} фото от официального застройщика`, statusText];

  if (housesCount) {
    statuses.splice(1, 0, `${housesCount} ${plural(housesCount, ['корпус', 'корпуса', 'корпусов'])}`);
  }

  return statuses;
};
